








import Vue from "vue";
import modalBus from "@/bus/modal-bus";

export default Vue.extend({
  name: "Menu",
  props: {},
  methods: {},
  components: {},
  computed: {},
  data() {
    return {
      isOn: false,
      style: {
        width: "100%",
        height: "100vh",
      },
    };
  },
  created() {
    const _this = this;
    //@ts-ignore
    modalBus.$on("set-size", (style) => {
      _this.style = style;
    });

    modalBus.$on("toggle", (state?: boolean) => {
      //@ts-ignore
      this.isOn = state !== undefined ? state : !this.isOn;

      if (this.isOn) {
        document.documentElement.style.overflow = "hidden";
      } else {
        document.documentElement.style.overflow = "auto";
      }
    });
  },
});
